module.exports = __webpack_public_path__ + "static/markWhite-09a740f567134bad5ea3749eff255ec2.svg";